import React from "react";
import { Form, Col } from "react-bootstrap";
import { RangeSlider } from "rsuite";

export default function HoursPicker({ formData, setFormData, name, extraClass }) {
    return (
        <Form.Group as={Col} controlId={`${name}-hours`} className={extraClass ? extraClass : "col-12 col-xl-2"}>
            <Form.Label>Hours</Form.Label>
            <RangeSlider
                max={24}
                size="md"
                value={formData.hourRange}
                onChange={value => setFormData({ ...formData, hourRange: value })}
                renderMark={mark => ([0, 24].includes(mark) ? <span>{mark}</span> : null)}
                graduated
            />
        </Form.Group>
    );
}
